
import {
    TablePage,
  } from 'src/views/cci/hspastclassification'
  import pathMap from 'src/paths/pathMap'
  
  class CciHsPastClassificationRoute {
    getConfigurations() {
      return [
        {
          exact: true,
          path: pathMap.CCI_HSCODE_PAST_CLASSIFICATION,
          component: TablePage
        }
      ]
    }
  }
  
  export default CciHsPastClassificationRoute